import FooterMain from './FooterMain';
import FooterCopyright from './FooterCopyright';

const Footer = () => {
    return (
        <footer>
            <FooterMain />
            <FooterCopyright />
        </footer >
    );
};

export default Footer;